import { createReducer, on } from "@ngrx/store";
import { InitialState } from "../state/online-contract.state";
import * as OnlineContractActions from '../actions/online-contract.actions';
import { HttpActionState } from "app/main/pages/users/userslisting/store/users-listing.reducers";

export const onlineContractReducer = createReducer(
    InitialState,
    on(OnlineContractActions.getOnlineContract, (state) => ({
        ...state,
        fetchOnlineContractRequestState: HttpActionState.Busy
    })),
    on(OnlineContractActions.getOnlineContractSuccess, (state, { template }) => ({
        ...state,
        template,
        fetchOnlineContractRequestState: HttpActionState.Done
    })),
    on(OnlineContractActions.getOnlineContractFailure, (state) => ({
        ...state,
        fetchOnlineContractRequestState: HttpActionState.Failed
    })),
    on(OnlineContractActions.signOnlineContract, (state) => ({
        ...state,
        signOnlineContractRequestState: HttpActionState.Busy
    })),
    on(OnlineContractActions.signOnlineContractSuccess, (state) => ({
        ...state,
        signOnlineContractRequestState: HttpActionState.Done
    })),
    on(OnlineContractActions.signOnlineContractFailure, (state) => ({
        ...state,
        signOnlineContractRequestState: HttpActionState.Failed
    })),
    on(OnlineContractActions.sendInvitation, (state) => ({
        ...state,
        sendOnlineContractInvitationRequestState: HttpActionState.Busy
    })),
    on(OnlineContractActions.sendInvitationSuccess, (state) => ({
        ...state,
        sendOnlineContractInvitationRequestState: HttpActionState.Done
    })),
    on(OnlineContractActions.sendInvitationFailure, (state) => ({
        ...state,
        sendOnlineContractInvitationRequestState: HttpActionState.Failed
    })),
    on(OnlineContractActions.addVisitedRecipientRole, (state, { role }) => ({
        ...state,
        visitedRoles: [...state.visitedRoles, ...role],
    })),

    on(OnlineContractActions.updateVisitedRecipientRole, (state, { updatedRole }) => {
        const transformRole = (role) => ({
            ...role,
            personfields: role.personfields?.map(item => {
            if (item?.key === "phone_no" && item?.value?.e164Number) {
                const country = item?.value?.countryCode ? String(item.value.countryCode).toLowerCase() : null;
                return {
                    ...item,
                    value: item?.value?.e164Number,
                    landcode: country
                };
            }
            return item;
            }) ?? []
        });
        const transformedRole = transformRole(updatedRole);
        return {
            ...state,
            visitedRoles: state.visitedRoles.map(role =>
                role.id === updatedRole.id ? transformedRole : transformRole(role)
            )
        };
    })
)